/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.2 (2021-11-17)
 */

const getContentStyle = function (editor) {
  return editor.getParam('content_style', '', 'string');
};
const shouldUseContentCssCors = function (editor) {
  return editor.getParam('content_css_cors', false, 'boolean');
};
const getBodyClassByHash = function (editor) {
  const bodyClass = editor.getParam('body_class', '', 'hash');
  return bodyClass[editor.id] || '';
};
const getBodyClass = function (editor) {
  const bodyClass = editor.getParam('body_class', '', 'string');
  if (bodyClass.indexOf('=') === -1) {
    return bodyClass;
  } else {
    return getBodyClassByHash(editor);
  }
};
const getBodyIdByHash = function (editor) {
  const bodyId = editor.getParam('body_id', '', 'hash');
  return bodyId[editor.id] || bodyId;
};
const getBodyId = function (editor) {
  const bodyId = editor.getParam('body_id', 'tinymce', 'string');
  if (bodyId.indexOf('=') === -1) {
    return bodyId;
  } else {
    return getBodyIdByHash(editor);
  }
};

const getPreviewHtml = function (editor, tinymce) {
  let headHtml = '';
  const encode = editor.dom.encode;
  const contentStyle = getContentStyle(editor);
  headHtml += '<base href="' + encode(editor.documentBaseURI.getURI()) + '">';
  const cors = shouldUseContentCssCors(editor) ? ' crossorigin="anonymous"' : '';
  tinymce.util.Tools.each(editor.contentCSS, function (url) {
    headHtml +=
      '<link type="text/css" rel="stylesheet" href="' +
      encode(editor.documentBaseURI.toAbsolute(url)) +
      '"' +
      cors +
      '>';
  });
  if (contentStyle) {
    headHtml +=
      '<style type="text/css">' +
      contentStyle +
      '.fa-angle-down{margin-right:15px;}.rotate{margin-right:21px;}' +
      '</style>';
  }
  const bodyId = getBodyId(editor);
  const bodyClass = getBodyClass(editor);
  const isMetaKeyPressed = tinymce.Env.mac ? 'e.metaKey' : 'e.ctrlKey && !e.altKey';
  const preventClicksOnLinksScript =
    '<script>' +
    'document.addEventListener && document.addEventListener("click", function(e) {' +
    'for (const elm = e.target; elm; elm = elm.parentNode) {' +
    'if (elm.nodeName === "A" && !(' +
    isMetaKeyPressed +
    ')) {' +
    'e.preventDefault();' +
    '}' +
    'if(e.target && e.target.className.includes("accordion-heading-button")){' +
    'const panel = e.target.nextElementSibling;' +
    'if (panel.style.display === "none") {' +
    'panel.style.display = "block";' +
    'e.target.classList.replace("caret-icon", "caret-icon-rotated");' +
    '} else {' +
    'panel.style.display = "none";' +
    'e.target.classList.replace("caret-icon-rotated", "caret-icon");' +
    '}' +
    '}' +
    '}' +
    '}, false);' +
    'const panels = document.getElementsByClassName("accordion-panel");' +
    'for (let i = 0; i < panels.length; i++) {' +
    'panels[i].style.display = "none";' +
    '}' +
    'const accordionButtons = document.getElementsByClassName("accordion-heading-button");' +
    'for (let i = 0; i < accordionButtons.length; i++) {' +
    'accordionButtons[i].classList.replace("caret-icon-rotated", "caret-icon");' +
    '}' +
    '</script> ';
  const directionality = editor.getBody().dir;
  const dirAttr = directionality ? ' dir="' + encode(directionality) + '"' : '';
  const previewHtml =
    '<!DOCTYPE html>' +
    '<html>' +
    '<head>' +
    headHtml +
    '</head>' +
    '<body id="' +
    encode(bodyId) +
    '" class="mce-content-body ' +
    encode(bodyClass) +
    '"' +
    dirAttr +
    '>' +
    editor.getContent() +
    preventClicksOnLinksScript +
    '</body>' +
    '</html>';
  return previewHtml;
};

const open = function (editor, tinymce) {
  const content = getPreviewHtml(editor, tinymce);
  const dataApi = editor.windowManager.open({
    title: 'Preview',
    size: 'large',
    body: {
      type: 'panel',
      items: [
        {
          name: 'preview',
          type: 'iframe',
          sandboxed: true,
        },
      ],
    },
    buttons: [
      {
        type: 'cancel',
        name: 'close',
        text: 'Close',
        primary: true,
      },
    ],
    initialData: { preview: content },
  });
  dataApi.focus('close');
};

const register$1 = function (editor, tinymce) {
  editor.addCommand('mceHaPreview', function () {
    open(editor, tinymce);
  });
};

const register = function (editor) {
  const onAction = function () {
    return editor.execCommand('mceHaPreview');
  };
  editor.ui.registry.addButton('haPreviewPlugin', {
    icon: 'preview',
    tooltip: 'Preview',
    onAction: onAction,
  });
};

const haPreviewPlugin = function (editor, tinymce) {
  register$1(editor, tinymce);
  register(editor);
};

export { haPreviewPlugin };
